import { useEffect } from 'react';
import { useError } from './contexts/ErrorContext';
import AppRoutes from './routes';

const AppContent = () => {
  const { showError } = useError();

  useEffect(() => {
    const handleApiError = (event: CustomEvent) => {
      showError(event.detail);
    };

    window.addEventListener('apiError', handleApiError as EventListener);
    return () => {
      window.removeEventListener('apiError', handleApiError as EventListener);
    };
  }, [showError]);

  return <AppRoutes />;
};

export default AppContent; 